import { useApplication } from '@/hooks/useApplication';
import { useSubroutine } from '@/hooks/useSubroutine';
import { Subroutine } from '@/types/subroutine';
import { startType } from '@/util/blocks';
import { getFolderLabels } from '@/util/folder';
import { sortSubroutines } from '@/util/sort';
import { subroutineUtil } from '@/util/validation/subroutines';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { FC, useEffect, useState } from 'react';
import { ParamProps } from './ParamRenderer';

const ParamSubroutine: FC<ParamProps> = (props) => {
  const { application } = useApplication();
  const { sortSubroutinesBy } = useSubroutine();

  const initialValue = subroutineUtil().getValue(props.configuration, props.initialValue);

  const [subroutines, setSubroutines] = useState<Subroutine[]>();

  const getSubroutineFolder = (subroutine: Subroutine): Subroutine => {
    const result = subroutine.folder ? getFolderLabels(subroutine.folder, application) + '.' : '';
    return { ...subroutine, label: result + subroutine.label };
  };

  useEffect(() => {
    let subroutinesToSort = application.subroutines.map((subroutine) => getSubroutineFolder(subroutine));
    if (props.configuration.value === 'substart') {
      subroutinesToSort = subroutinesToSort.filter(
        (subroutine) => startType(subroutine, application.blocks) === 'SubStart'
      );
    } else if (props.configuration.value === 'eventstart') {
      subroutinesToSort = subroutinesToSort.filter(
        (subroutine) => startType(subroutine, application.blocks) === 'EventStart'
      );
    }
    const sortedSubroutines = sortSubroutines(sortSubroutinesBy, subroutinesToSort);
    sortedSubroutines && setSubroutines(sortedSubroutines);
  }, [application.subroutines, application.blocks.nodes, sortSubroutinesBy]);

  return (
    <Autocomplete
      disablePortal
      size='small'
      fullWidth
      value={subroutines?.find((sub) => sub.id === initialValue) || null}
      onChange={(_, value) => props.onChange([props.configuration.value, value?.id])}
      options={subroutines || []}
      getOptionLabel={(option) => (subroutines ? option.label : '')}
      renderInput={(params) => <TextField {...params} placeholder={props.configuration.label} fullWidth />}
    />
  );
};

export default ParamSubroutine;
